var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFileVue = function SvgIconFileVue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.875 2.375h9.75a1 1 0 0 1 .707.293l5.25 5.25a1 1 0 0 1 .293.707v3a1 1 0 1 1-2 0v-1.25h-5a1 1 0 0 1-1-1v-5h-7.75v7.25a1 1 0 1 1-2 0v-7.5a1.75 1.75 0 0 1 1.75-1.75m10 2.664 3.336 3.336h-3.336z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.635 14.444a1 1 0 0 1 1.296.565l1.132 2.881 1.132-2.88a1 1 0 0 1 1.861.73l-2.062 5.25a1 1 0 0 1-1.862 0L2.07 15.74a1 1 0 0 1 .565-1.296M17.625 14.375a1 1 0 0 0-1 1v5.25a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2h-2V19h1.625a1 1 0 1 0 0-2h-1.625v-.625h2a1 1 0 1 0 0-2zM11.125 15.375a1 1 0 1 0-2 0v3.375a2.875 2.875 0 1 0 5.75 0v-3.375a1 1 0 1 0-2 0v3.375a.875.875 0 1 1-1.75 0z"
  }))));
};
export default SvgIconFileVue;